import { IndustrySite } from "./components/industry/IndustrySite";

/** Plantilla original: toda la página (encabezado, secciones y pie) se compone en IndustrySite a partir de content/industry.ts. */
export default function App() {
  return <IndustrySite />;
}
